import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import * as cookie from 'cookie';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { useState } from 'react';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';
import CategoriesSidebarWrapper from '@/components/ShopComp/CategoriesSidebarWrapper';
import BooksListWrapper from '@/components/ShopComp/ProductListWrapper';
import HeroSection from '@/components/V2/HomePage/HeroSection';

import { detectCountry, getActiveCountries } from '@/services/globalCountry';
import { getAllProductsSSR } from '@/services/LandingPage';
import { formatEcomProductCourses } from '@/utils/ProductFormaterBooks';

interface Props {
  ecomProducts: any[];
}

const CategoryPage: React.FC<Props> = ({ ecomProducts }) => {

  const [searchKeyword, setSearchKeyword] = useState<string>('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchKeyword = e.target.value;
    setSearchKeyword(newSearchKeyword);
  };

  const screens = useBreakpoint();



  return (
    <>
      <Head>
        <title>
          Explore Finance Books at ZebraLearn: Your Online Bookstore
        </title>
        <meta
          name='description'
          content='Discover best books publisher in India specializing in non-fiction books. ZebraLearn offers cutting-edge design & technology insights, simplifying complex topics.
      '
          key='description'
        />
      </Head>
      <div className='flex flex-col'>
        <HeroSection />
        <div className='text-white pt-2 lg:pt-6 lg:px-12'>
          <div className='flex flex-col md:flex-row'>
            <ShouldRender check={screens.lg}>
              <CategoriesSidebarWrapper
                handleInputChange={handleInputChange}
                searchKeyword={searchKeyword}
                setSearchKeyword={setSearchKeyword}
                type='courses'
              />
            </ShouldRender>
            <div className='flex-1  md:px-6'>
              <BooksListWrapper
                handleInputChange={handleInputChange}
                searchKeyword={searchKeyword}
                setSearchKeyword={setSearchKeyword}
                type='courses'
                ecomProducts={ecomProducts}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  try {
    const { req } = ctx;

    const rawCookies = req.headers.cookie || '';
    const parsedCookies = cookie.parse(rawCookies);

    let country = parsedCookies['country']?.trim();

    if (!country) {
      const [activeCountries, detectedCode] = await Promise.all([
        getActiveCountries(),
        detectCountry(req),
      ]);

      if (activeCountries.length > 0) {
        const fallback = activeCountries.find((c: any) => c.code === 'IN');
        const found =
          activeCountries.find((c: any) => c.code === detectedCode) || fallback;

        country = found?.code || 'IN';
      }
    }

    const allCoursesData = await getAllProductsSSR({
      page: 1,
      limit: 9999,
      category_id: 5,
      country: country as string,
    });

    const formattedecomProductsData = formatEcomProductCourses(
      allCoursesData || [],
    );

    return {
      props: {
        ecomProducts: formattedecomProductsData,
      },
    };
  } catch (error) {
    console.error('Error fetching SSR data:', error);

    return {
      props: {
        ecomProducts: [],
      },
    };
  }
};

export default CategoryPage;
